import React from 'react';
import { HeartPulse, AlertTriangle } from 'lucide-react';

/**
 * Компонент для выбора состояний здоровья
 */
const HealthConditionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  healthConditionsList 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HeartPulse className="w-5 h-5 mr-2 text-green-500" />
        Состояние здоровья
      </h3>
      
      <div className="mb-4">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Выберите, если у вас есть следующие состояния:
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
          {healthConditionsList.map(condition => (
            <label key={condition.id} className={`
              inline-flex items-center p-3 border rounded-lg cursor-pointer hover:bg-green-100 dark:hover:bg-green-900/30 transition-colors
              ${formData.healthConditions.includes(condition.id) 
                ? 'bg-green-100 dark:bg-green-900/30 border-green-300 dark:border-green-700' 
                : 'border-gray-200 dark:border-gray-700'}
              ${condition.factor === 0.0 ? 'border-l-4 border-l-yellow-500 dark:border-l-yellow-600' : ''}
            `}>
              <input
                type="checkbox"
                name={`health_${condition.id}`}
                checked={formData.healthConditions.includes(condition.id)}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <div className="ml-2">
                <span className="text-sm text-gray-700 dark:text-gray-300 font-medium">{condition.name}</span>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{condition.description}</p>
              </div>
            </label>
          ))}
        </div>
        {errors.healthConditions && (
          <p className="mt-2 text-sm text-yellow-600 dark:text-yellow-400 flex items-center">
            <AlertTriangle className="w-4 h-4 mr-1 flex-shrink-0" />
            {errors.healthConditions}
          </p>
        )}
      </div>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-200 dark:border-yellow-800">
        <div className="flex items-start">
          <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
              Важное предупреждение
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              Если у вас есть заболевания почек, сердечно-сосудистой системы, отеки или 
              другие состояния, отмеченные желтой полосой, норма потребления воды должна 
              определяться лечащим врачом. Наш расчет является приблизительным и может не 
              учитывать особенности вашего состояния здоровья.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthConditionsSection;